import * as React from 'react'
import ProductHeader from '../ProductHeader'
import ProductImageViewer from '../ProductImageViewer'
import ProductInfo from '../ProductInfo'
import StickyProductActions from '../StickyProductActions'
import { ProductHeroProps } from './ProductHero.types'
import * as S from './ProductHero.styles'
import ProductCarousels from './ProductCarousels'

const ProductHero: React.FC<ProductHeroProps> = ({
  productInfo,
  showStockNotifyBtn,
  cartInfo,
  stripePublishableKey,
  stripePublishableKeys,
  isWalletPaymentOn
}) => {
  const [selectedId, setSelectedId] = React.useState(productInfo.selectedId)
  const [selectedSizeConversionId, setSelectedSizeConversionId] =
    React.useState(productInfo.selectedSizeConversionId)
  const [selectedPriceCents, setSelectedPriceCents] = React.useState(
    productInfo.selectedPriceCents
  )
  const [selectedFormattedDisplayPrice, setSelectedFormattedDisplayPrice] =
    React.useState(productInfo.selectedFormattedDisplayPrice)
  const [showModal, setShowModal] = React.useState(false)

  // https://medium.com/geekculture/hide-and-replace-sticky-element-on-scrolling-in-a-react-way-8bc3f04e2a81
  const getOffset = (el: HTMLElement | null) => {
    const element = el?.getBoundingClientRect()

    return element?.top
  }

  React.useEffect(() => {
    const listenToScroll = () => {
      const heightToHide = getOffset(document.getElementById('product-actions'))

      if (heightToHide !== undefined && heightToHide < 0) {
        setShowModal(true)
      } else {
        setShowModal(false)
      }
    }

    window.addEventListener('scroll', listenToScroll)

    return () => window.removeEventListener('scroll', listenToScroll)
  }, [])

  const inStock =
    selectedSizeConversionId &&
    selectedPriceCents &&
    selectedFormattedDisplayPrice &&
    selectedId

  return (
    <>
      <S.ProductHeroWrapper>
        <ProductHeader
          className="hide-desktop"
          captain={productInfo.captain}
          title={productInfo.title}
        />
        <S.ProductHeroImages>
          <ProductImageViewer
            productTitle={productInfo.title}
            primaryImageUrl={productInfo.imageUrl}
            imageUrls={productInfo.imageUrls}
          />
        </S.ProductHeroImages>
        <S.ProductHeroInfo>
          <ProductInfo
            inStock={inStock}
            selectedPriceCents={selectedPriceCents}
            setSelectedPriceCents={setSelectedPriceCents}
            selectedSizeConversionId={selectedSizeConversionId}
            setSelectedSizeConversionId={setSelectedSizeConversionId}
            selectedFormattedDisplayPrice={selectedFormattedDisplayPrice}
            setSelectedFormattedDisplayPrice={setSelectedFormattedDisplayPrice}
            productInfo={productInfo}
            showStockNotifyBtn={showStockNotifyBtn}
            cartInfo={cartInfo}
            isWalletPaymentOn={isWalletPaymentOn}
            stripePublishableKey={stripePublishableKey}
            stripePublishableKeys={stripePublishableKeys}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
          />
        </S.ProductHeroInfo>
        {showModal && inStock ? (
          <StickyProductActions
            productInfo={productInfo}
            selectedSizeConversionId={selectedSizeConversionId}
            selectedPriceCents={selectedPriceCents}
            selectedFormattedDisplayPrice={selectedFormattedDisplayPrice}
            selectedId={selectedId}
          />
        ) : null}
      </S.ProductHeroWrapper>
      <ProductCarousels productId={productInfo.productId.toString()} />
    </>
  )
}

export default ProductHero
